<template>
    <div class="groups-members profile-list">
        <user v-if="type !== 'members'" v-for="member in allMembers" :owner="owner" :key="member.id" :user="member">
            <ul slot="menu" v-if="type === 'banned'" class="dropdown-menu">
                <li><a href="#" @click.prevent="updateMember('unban', member)">{{ t.unban }}</a></li>
            </ul>
            <div slot="buttons" v-if="type === 'pending'" class="buttons two-buttons">
                <a href="#" class="btn btn-success btn-sm" @click.prevent="updateMember('approve', member)">{{ t.approve }}</a>
                <a href="#" class="btn btn-danger btn-sm" @click.prevent="updateMember('deny', member)">{{ t.deny }}</a>
            </div>
            <div slot="buttons" v-if="type === 'invited'" class="buttons one-button">
                <a href="#" class="btn btn-danger" @click.prevent="removeInvite(member)">{{ gt.common.cancel }}</a>
            </div>
        </user>
        <user v-if="type === 'members'" v-for="member in allMembers" :owner="owner" :key="member.id" :user="member">
            <ul slot="menu" class="dropdown-menu">
                <li v-if="member.role !== 7"><a href="#" @click.prevent="updateMember('ban', member)">{{ t.ban }}</a></li>
                <li><a href="#" @click.prevent="showChangeRole(member)">Change Role</a></li>
                <li v-if="member.role !== 7"><a href="#" @click.prevent="updateMember('remove', member)">{{ t.remove }}</a></li>
            </ul>
        </user>
        <div class="clearfix"></div>
        <infinite v-if="canLoadMore && type === 'members' && infinite" :loading="loading" :handleOnMount="false" :handler="fetch"></infinite>
        <modal v-model="changeRoleModal.show" v-on:submit="changeRole" :title="changeRoleModal.title" :submit="t.change_role">
            <select class="form-control" v-model="changeRoleModal.value">
                <option value="1">{{ t.member }}</option>
                <option value="6">{{ t.moderator }}</option>
                <option value="7">{{ t.administrator }}</option>
            </select>
        </modal>
    </div>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import Infinite from 'Site/component/Infinite.vue';
import Modal from 'Site/component/Modal.vue';
import User from 'Profile/component/User.vue';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'GroupMembers',
    components: {
        Infinite,
        Modal,
        User
    },
    computed: mapState({
        gt: state => state.gt,
        t: state => state.t.members
    }),
    data() {
        return {
            allMembers: this.members,
            canLoadMore: true,
            changeRoleModal: {
                show: false,
                title: this.$store.state.t.change_role,
                value: 1,
                member: {}
            },
            loading: false,
            offset: 25
        };
    },
    methods: {
        ...mapActions(['notify']),
        changeRole() {
            ajax.update('members', {
                id: this.changeRoleModal.member.id,
                group: this.$store.state.config.data.id,
                action: 'role',
                role: this.changeRoleModal.value
            }).then(() => {
                this.changeRoleModal.show = false;
                this.notify({ msg: this.t.username_role_has_been_updated.replace('%username', this.changeRoleModal.member.identity) });
            });
        },
        removeInvite(member) {
            ajax.delete('groupInvite', {
                id: member.entity_id
            }).then((response) => {
                this.allMembers = this.allMembers.filter(checkMember => checkMember.id !== parseInt(member.id, 10));
                this.notify({ msg: response.message });
            });
        },
        showChangeRole(member) {
            this.changeRoleModal.value = member.role;
            this.changeRoleModal.title = this.t.change_username_role.replace('%username', member.identity);
            this.changeRoleModal.show = true;
            this.changeRoleModal.member = member;
        },
        fetch() {
            this.loading = true;
            ajax.get('members', {
                group: this.$store.state.config.data.id,
                'start-index': this.offset,
                'max-results': 25
            }).then((response) => {
                this.loading = false;
                this.offset += 25;
                if (response.items && response.items.length) {
                    response.items.forEach((item) => {
                        this.allMembers.push(item);
                    });
                } else {
                    this.canLoadMore = false;
                }
            });
        },
        updateMember(action, member) {
            ajax.update('members', {
                id: member.id,
                group: this.$store.state.config.data.id,
                action
            }).then((response) => {
                this.allMembers = this.allMembers.filter(checkMember => checkMember.id !== parseInt(member.id, 10));
                this.notify({ msg: response.message });
                this.$emit('groupmemberchange', { action, member });
            });
        }
    },
    props: {
        infinite: {
            type: Boolean,
            default: false
        },
        members: Array,
        owner: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'members'
        }
    }
};

</script>

<style>
.group-members {
    margin-bottom: 15px;
}
</style>
